<template>
  <transition name='fade'>
    <div class="modal video_view"
         v-if='visible'>
      <div class="video_view_content"
           style="height:200px;">
        <div class="video_view_title msp_icon_close">
          <span>{{audioInfo.title}}</span>
          <span class="iconfont el-icon-close"
                @click.stop='closeBox()'></span>
        </div>
        <audio :src="audioInfo.url"
               class="video"
               :style="{width : '100%',height:'100px'}"
               controls="controls"></audio>
      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'previewAudio',
  data() {
    return {
      visible: false,
      audioInfo: ''
    }
  },
  mounted() {
    this.$root.eventHub.$on('previewAudioModel', (data) => {
      this.visible = true
      this.audioInfo = data
    })


  },
  destroyed() {
    this.$root.eventHub.$off('previewAudioModel')
  },
  components: {

  },
  methods: {
    closeBox() {
      this.visible = false
    },

  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
@import '../../../styles/preview.styl'
</style>
